import { createGetAllApi } from "@api/util/createGetAllApi";
import { createGetApi } from "@api/util/createGetApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";
import type { IPurchaseInvoicesReturnsResponse } from "@api/stores/purchaseInvoices/returns/types";

import type { IPathBaseParam, IPathByIdParam } from "./path";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IPurchaseInvoicesReturnsResponse>>,
  IPathBaseParam,
  IPaginationParams
>("stores.purchaseInvoiceReturns");

const getApis = createGetApi<
  IApiResponse<IPurchaseInvoicesReturnsResponse>,
  IPathByIdParam,
  object
>("stores.purchaseInvoiceReturns");

export const purchaseInvoiceReturns = {
  ...getAllApis,
  ...getApis,
};
